import { Component } from '@hatiolab/things-scene'

import ControlBase, { DIRECTION, INOUT, NODE, PIPELINE } from './base/control-base'

const IMAGE = new URL('../icons/test-message.png', import.meta.url).href

const NATURE = {
  mutable: false,
  resizable: false,
  rotatable: false,
  properties: []
}

export default class TestMessage extends ControlBase {
  static IMAGE: HTMLImageElement

  static get nature() {
    return NATURE
  }

  get nodes(): NODE[] {
    return [
      {
        name: 'OutMessage',
        description: 'Message outlet',
        inout: INOUT.OUT,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.EAST
      }
    ]
  }

  getImageElement(): HTMLImageElement {
    if (!TestMessage.IMAGE) {
      TestMessage.IMAGE = new Image()
      TestMessage.IMAGE.src = IMAGE
    }

    return TestMessage.IMAGE
  }
}

Component.register('test-message', TestMessage)
